import { ERROR_ACTIONS, type ErrorActionsType } from './ErrorDuck.actions'
import {
  addError,
  clearError,
  dismissError,
  updateRequestChain,
  updateState
} from '@aytm/app/insights/dashboard/helpers/requests'
import { duckName } from './constants'
import type {
  InsightsDashboardErrorTypes,
  InsightsDashboardPoolState
} from '@aytm/app/insights/dashboard/duckness/ducks/types'
import SagaDuck from '@duckness/saga'
import { withStateUpdates } from '@aytm/app/insights/dashboard/duckness/ducks/withStateUpdates'

type ErrorDuckSelectorsType = {
  getErrors: (state: InsightsDashboardPoolState) => InsightsDashboardPoolState['errors']
  hasErrors: (state: InsightsDashboardPoolState) => boolean
}

export const ErrorDuck = SagaDuck<InsightsDashboardPoolState, ErrorActionsType, ErrorDuckSelectorsType>(
  duckName,
  'insights-dashboard'
)
export default ErrorDuck

// actions
ErrorDuck.action(ERROR_ACTIONS.SET_ERROR)
ErrorDuck.action(ERROR_ACTIONS.DISMISS_ERROR)
ErrorDuck.action(ERROR_ACTIONS.CLEAR_ERRORS)

ErrorDuck.selector('getErrors', state => state.errors)
ErrorDuck.selector('hasErrors', state => Object.keys(state.errors || {}).length > 0)

// reducers
ErrorDuck.reducer('@@INIT', state => {
  return {
    ...state,
    errors: {} as Record<InsightsDashboardErrorTypes, string[]>
  }
})
/**
 * Clear typed errors from the state.
 */
ErrorDuck.reducer<{ types?: InsightsDashboardErrorTypes[] }>(ERROR_ACTIONS.CLEAR_ERRORS, (state, action) => {
  const { types } = action.payload
  return { ...state, errors: clearError(state.errors, types) }
})

ErrorDuck.reducer<{ type: InsightsDashboardErrorTypes }>(ERROR_ACTIONS.DISMISS_ERROR, (state, action) => {
  const { type } = action.payload
  return { ...state, errors: dismissError(state.errors, type) }
})

/**`
 * Set a typed error in the state.
 */
ErrorDuck.reducer<{
  type: InsightsDashboardErrorTypes
  error: Error | string | string[]
}>(ERROR_ACTIONS.SET_ERROR, (state, action) => {
  const { type, error } = action.payload
  return withStateUpdates(state)(
    state => updateState(state, { isLoading: false, isFreshLoading: false }),
    state => updateRequestChain(state, { currentIndex: -1 }),
    state => (!type || !error ? state : { ...state, errors: addError(state.errors, type, error) })
  )
})
